import {Component, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {KeycloakGuardService} from '@app/core';

import {CorpCalendarComponent} from './main/corp-calendar/corp-calendar.component';
import {DelegationComponent} from './main/delegation/delegation.component';
import {HomeComponent} from './main/home/home.component';
import {ServicesComponent} from './main/services/services.component';
import {ServiceUnavailableComponent} from './main/service-unavailable/service-unavailable.component';
import {WorklistComponent} from './main/worklist/worklist.component';

import {PaymentTermsAdminComponent} from '@app/finance/payment-terms-admin/payment-terms-admin.component';
import {EmployeeAppraisalComponent} from '@app/hcm/common/employee-appraisal/employee-appraisal.component';
import {HelpCenterComponent} from '@app/main/help-center/help-center.component';

//TODO fix me: should not be here...
import {SuggestionManagementComponent} from './main/suggestion-management/suggestion-management.component';
import {Roles} from "@app/shared";
import {OnboardingFilesComponent} from "@app/main/file-sharing/onboarding-files/onboarding-files.component";
import {MaintenanceFilesComponent} from "@app/main/file-sharing/maintenance-files/maintenance-files.component";
import {AppComponent} from "@app/app.component";
import {RealmSelectorComponent} from "@app/keycloak/realm-selector/realm-selector.component";
import {CheckAuthComponent} from "@app/keycloak/check-auth/check-auth.component";
import {KeycloakInfoComponent} from "@app/keycloak/keycloak-info/keycloak-info.component";


@Component({
  selector: 'empty',
  template: ''
})
export class EmptyComponent {
}


//TODO Angular Upgrade: Enable this after upgrade, by adding anchorScrolling=true, for fragment URL routing
/*const routerOptions: ExtraOptions = {
  useHash: true
}; */

//TODO Angular Upgrade: Load children syntax is being deprecated from Angular 8, https://angular.io/guide/deprecations#loadchildren-string-syntax
//Update all occurrences of loadChildren: 'app/finance/accounts-receivable/account-receivable.module#AccountReceivableModule' to newer syntaxes

// jC: default route to MainComponent
//     MUST specify onelynk roles for each and every component here
const routes: Routes = [
  {path: 'gateway', component: AppComponent},
  {path: 'realm-selector', component: RealmSelectorComponent},
  {path: 'check-auth', component: CheckAuthComponent},

  // { path: '**', component: LoginComponent },

  {
    path: 'keycloak-info', component: KeycloakInfoComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.OrgAdmin]}
  },

  // ToDo: lazy load corp-calendar
  {
    path: 'main/corp-calendar', component: CorpCalendarComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.Client]}
  },
  // ToDo: lazy load delegation
  {
    path: 'main/delegation', component: DelegationComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.Client]}
  },
  {
    path: 'main/home', component: HomeComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.Client]}
  },
  {
    path: 'main/help-center', component: HelpCenterComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.Client]}
  },
  {
    path: 'main/services', component: ServicesComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.Client]}
  },
  {
    path: 'main/suggestion', component: SuggestionManagementComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.Client]}
  },
  {
    path: 'main/services/:tabName', component: ServicesComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.Client]}
  },
  {
    path: 'main/service-unavailable', component: ServiceUnavailableComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.Client]}
  },
  {
    path: 'main/worklist', component: WorklistComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.Client]}
  },
  {
    path: 'main/file-sharing/onboarding-files', component: OnboardingFilesComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.OrgAdmin, Roles.CSRAdmin, Roles.SupportFile]}
  },
  {
    path: 'main/file-sharing/maintenance-files', component: MaintenanceFilesComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.OrgAdmin, Roles.CSRAdmin, Roles.SupportFile]}
  },
  {
    path: 'candidate',
    loadChildren: () => import('app/candidate/candidate.module').then(m => m.CandidateModule)
  },
  {
    path: 'customer',
    loadChildren: () => import('app/customer/customer.module').then(m => m.CustomerModule)
  },
  {
    path: 'finance/accounts-payable',
    loadChildren: () => import('app/finance/accounts-payable/accounts-payable.module').then(m => m.AccountsPayableModule)
  },
  {
    path: 'finance/accounts-receivable',
    loadChildren: () => import('app/finance/accounts-receivable/account-receivable.module').then(m => m.AccountReceivableModule)
  },
  {
    path: 'finance/expense',
    loadChildren: () => import('app/finance/expense/expense.module').then(m => m.ExpenseModule)
  },
  {
    path: 'finance/time',
    loadChildren: () => import('app/finance/time/time.module').then(m => m.TimeModule)
  },
  {
    path: 'finance/calendar',
    loadChildren: () => import('app/finance/finance-calendar/finance-calendar.module').then(m => m.FinanceCalendarModule)
  },
  // {
  //   path: 'finance/payment-register',
  //   loadChildren: 'app/finance/payment-register/payment-register.module#PaymentRegisterModule'
  // },
  {
    path: 'finance/voucher-register',
    loadChildren: () => import('app/finance/voucher-register/voucher-register.module').then(m => m.VoucherRegisterModule)
  },
  {
    path: 'finance/general-ledger',
    loadChildren: () => import('app/finance/general-ledger/general-ledger.module').then(m => m.GeneralLedgerModule)
  },
  {
    path: 'finance/financial-report',
    loadChildren: () => import('app/finance/financial-report/financial-report.module').then(m => m.FinancialReportModule)
  },
  {
    path: 'hcm/ess',
    loadChildren: () => import('app/hcm/ess/hcm-ess.module').then(m => m.HcmEssModule)
  },
  {
    path: 'hcm/mss',
    loadChildren: () => import('app/hcm/mss/hcm-mss.module').then(m => m.HcmMssModule)
  },
  {
    path: 'hcm/hr',
    loadChildren: () => import('app/hcm/hr/hcm-hr.module').then(m => m.HcmHrModule)
  },
  {
    path: 'item-catalog',
    loadChildren: () => import('app/item-catalog/item-catalog.module').then(m => m.ItemCatalogModule)
  },
  {
    path: 'payroll',
    loadChildren: () => import('app/payroll/payroll.module').then(m => m.PayrollModule)
  },
  {
    path: 'procurement',
    loadChildren: () => import('app/procurement/procurement.module').then(m => m.ProcurementModule)
  },
  {
    path: 'project',
    loadChildren: () => import('app/project/project.module').then(m => m.ProjectModule)
  },
  {
    path: 'reporting',
    loadChildren: () => import('app/reporting/reporting.module').then(m => m.ReportingModule)
  },
  {
    path: 'solution-manager',
    loadChildren: () => import('app/solution-manager/solution-manager.module').then(m => m.SolutionManagerModule)
  },
  {
    path: 'trading-partner',
    loadChildren: () => import('app/trading-partner/trading-partner.module').then(m => m.TradingPartnerModule)
  },
  {
    path: 'test',
    loadChildren: () => import('app/test/test.module').then(m => m.TestModule)
  },
  {
    path: 'finance/charge-code',
    loadChildren: () => import('app/finance/charge-code/charge-code.module').then(m => m.ChargeCodeModule)
  },

  // Lazy load the following components later
  {
    path: 'finance/payment-terms-admin', component: PaymentTermsAdminComponent, canActivate: [KeycloakGuardService],
    data: {roles: [Roles.PaymentTermsAdmin]}
  },

  // { path: '', component: EmptyComponent },

  {path: 'hcm/common/employee-appraisal', component: EmployeeAppraisalComponent},

  {
    path: 'hcm/recruit-to-hire',
    loadChildren: () => import('app/hcm/recruit-to-hire/hcm-recruit-to-hire.module').then(m => m.HcmRecruitToHireModule)
  },

  {
    path: 'dashboard/main',
    loadChildren: () => import('app/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'cyberplan',
    loadChildren: () => import ('@app/cyberplan/cyberplan.module').then(m => m.CyberplanModule)
  },
  //
  // { path: '**', component: PageNotFoundComponent }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'}),
  ],
  declarations: [
    EmptyComponent
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
